import { __assign } from "tslib";
import React from 'react';
import { Button, IconButton } from '../../../buttons';
import { FilterIcon } from './filter.icon';
import classNames from 'classnames';
import styles from './filter-button.module.css';
import { useMediaQuery } from '../../../../library';
export function FilterButton(props) {
    var _a = props.label, label = _a === void 0 ? 'Filters' : _a, _b = props.active, active = _b === void 0 ? false : _b;
    var cleansedProps = __assign(__assign({}, props), { label: void 0, type: void 0 });
    var isMobile = useMediaQuery('screen and (max-width: 580px)');
    return (React.createElement(React.Fragment, null, isMobile ? (React.createElement(IconButton, __assign({}, cleansedProps, { iconType: "fill", borderColour: active ? 'secondary' : 'borders', borderRadius: "10px", backgroundColour: "cards" }),
        React.createElement(FilterIcon, { tone: active ? 'primary' : 'accent-3' }))) : (React.createElement(Button, __assign({}, cleansedProps, { type: "button", theme: "dark", square: true, className: classNames({ active: active }) }),
        React.createElement("div", { className: styles.filterButtonSleeve },
            React.createElement(FilterIcon, { tone: active ? 'primary' : 'accent-3' }),
            React.createElement("span", null, label))))));
}
FilterButton.displayName = 'FilterButton';
export default FilterButton;
